import React, { useCallback } from 'react';
import { Tab, Tabs } from '@mui/material';
import { useRecoilState } from 'recoil';
import stateResultMode from '../../../state/stateResultMode';

const TAB_VALUES: BeaconFilterItem[] = [
  { id: 'genomic', label: 'Genomic' },
  { id: 'clinical', label: 'Clinical' },
  { id: 'radiomics', label: 'Radiomics' },
];

function ResultsViewSelector() {
  const [resultsView, setResultsView] = useRecoilState(stateResultMode);
  const handleChange = useCallback(
    (event: React.SyntheticEvent<Element, Event>, value: any) => {
      if (value !== resultsView) {
        setResultsView(value);
      }
    },
    [resultsView, setResultsView]
  );

  return (
    <Tabs centered value={resultsView} onChange={handleChange}>
      {TAB_VALUES.map((elem) => (
        <Tab key={elem.id} value={elem.id} label={elem.label} />
      ))}
    </Tabs>
  );
}

export default ResultsViewSelector;
